module.exports = __webpack_public_path__ + "static/img/3.c43b88d.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/poster/3.png
// module id = +6p+
// module chunks = 1